module.exports = __webpack_public_path__ + "static/media/hotel.3eed1548.svg";